import { Input } from "components/atoms";
import { List } from "components/molecules";
import { Accordion } from "components/organism";
import { cl, co, mx } from "_utilities/flags";

const countryList = {
  cl,
  co,
  mx
};

const ListSalesChannels = ({ country, elements, flag, onToggle }) => {
  return (
    <Accordion title={<>
      <span>{country}</span>
      <img
        alt={flag}
        src={countryList[flag]} 
        className="w-5"
      />
    </>}>
      <List elements={elements?.map((e, i) => ({
        className: "px-3 py-1 cursor-pointer",
        content: (
          <div className="flex flex-wrap justify-between" key={i}>
            <span>{e.content}</span> <Input className="hover:cursor-pointer" type="checkbox" value={e.key} onClick={() => onToggle(e.key)} />
          </div>
        )
      }))}>
      </List>
    </Accordion>
  );
};

export default ListSalesChannels;
